import clamp from 'lodash/clamp';
import { LINEAR_ZOOM_STEP, MAXIMUM_ZOOM_LEVEL, MINIMUM_ZOOM_LEVEL } from './ellipsis.tsx';
import type { Zoom } from './ListEdgeDetails.tsx';
import type { ZoomDirection } from './directionKeys.tsx';

const EXPONENTIAL_ZOOM_BASE = 2;
const LOGARITHMIC_ZOOM_BASE = Math.log(2);

// convert exponential diagram zoom to a linear ak-range accessible value
export const getLinearZoom = (exponentialZoom: Zoom): number =>
	Math.log(exponentialZoom) / LOGARITHMIC_ZOOM_BASE;

// convert linear ak-range value to exponential diagram zoom value
export const getExponentialZoom = (linearZoom: Zoom): number => EXPONENTIAL_ZOOM_BASE ** linearZoom;

export const clampZoom = (
	zoom: number,
	minZoom: number = MINIMUM_ZOOM_LEVEL,
	maxZoom: number = MAXIMUM_ZOOM_LEVEL,
): number => clamp(zoom, minZoom, maxZoom);

export const getNextZoomStep = (
	zoom: number,
	direction: ZoomDirection,
	minZoom: number = MINIMUM_ZOOM_LEVEL,
	maxZoom: number = MAXIMUM_ZOOM_LEVEL,
): number => {
	const step = direction === 'IN' ? LINEAR_ZOOM_STEP : -LINEAR_ZOOM_STEP;

	const nextLinearZoom = getLinearZoom(zoom) + step;
	const nextZoom = getExponentialZoom(nextLinearZoom);

	return clampZoom(nextZoom, minZoom, maxZoom);
};
